import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiElectricalConnectionConstants } from "../../constants/api-constants/api-electrical-connection.constants";
let ElectricalConnectionService = class ElectricalConnectionService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiElectricalConnectionConstants.URL}/${applicationId}/${ApiElectricalConnectionConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ElectricalConnectionService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ElectricalConnectionService);
export { ElectricalConnectionService };
